import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef  } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { SpinnerService, SpinnerState } from './spinner.service';
@Component({
    selector: 'tmb-spinner',
    templateUrl: 'spinner.component.html'
})
export class SpinnerComponent implements OnInit, OnDestroy  {
    public show = false;
    private subscription: Subscription;
    constructor(
        private loaderService: SpinnerService,
        private cdRef: ChangeDetectorRef
    ) { }
    ngOnInit() {
        this.subscription = this.loaderService.spinnerState
            .subscribe((state: SpinnerState) => {
                this.show = state.show;
                this.cdRef.detectChanges();
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/spinner/spinner.component.ts